{
  "kk": {
    "mainPageHeader": {
      "profile": "Профиль",
      "travel": "Саяхат",
      "close": "Жабу",
      "myTours": "Менің турларым",
      "myTickets": "Билеттерім",
      "passengers": "Жолаушылар",
      "customerSupport": "Қолдау қызметі"
    }
  },
  "ru": {
    "mainPageHeader": {
      "profile": "Профиль",
      "travel": "Путешествия",
      "close": "Закрыть",
      "myTours": "Мои туры",
      "myTickets": "Мои билеты",
      "passengers": "Пассажиры",
      "customerSupport": "Служба поддержки"
    }
  },
  "en": {
    "mainPageHeader": {
      "profile": "Profile",
      "travel": "Travel",
      "close": "Close",
      "myTours": "My Tours",
      "myTickets": "My Tickets",
      "passengers": "Passengers",
      "customerSupport": "Customer Support"
    }
  }
}
